export const ABOUT = 'About';
export const ACCEPT_PAYMENT_PLAN = 'Accept Payment Plan';
export const ADVERTISER_SUBSCRIPTION_CATEGORY = 'Advertiser subscription';
export const ADYEN_PAYMENT_RESULT = 'Adyen payment result';
export const ALL_ROLES = 'All roles';
export const APOLLO_CITY = 'City';
export const APOLLO_COMMUNITY = 'Community';
export const APOLLO_COUNTRY = 'CountryGuide';
export const APOLLO_GUIDE = 'Guide';
export const APOLLO_SUPPLY_LANDING = 'Supply landing';
export const APOLLO_UNIVERSITY = 'UniLanding';
export const APOLLO_UNIVERSITY_SIGN_UP = 'UniSignup';
export const BILLING = 'Billing';
export const BILLING_SUBSCRIPTION_ACTIVATE = 'Payment form';
export const BILLING_SUBSCRIPTION_LANDING = 'Product selection';
export const BLOG_ADVERTISER = 'Blog advertiser';
export const BLOG_CITY = 'Blog city';
export const BLOG_COUNTRY = 'Blog country';
export const BLOG_TENANT = 'Blog tenant';
export const BOOKING = 'Booking';
export const BOOKING_LINK_PAGE = 'Booking Link';
export const CAREERS = 'Careers';
export const CITY = 'City';
export const COMMISSION_PLAN = 'Commission Plan';
export const CONTACT = 'Contact';
export const CONTACT_ADVERTISER = 'Contact advertiser';
export const COOKIES_POLICY = 'Cookies policy';
export const COOKIES_TABLE = 'Cookies table';
export const COUNTRY = 'Country';
export const CULTURE = 'Culture';
export const CUSTOMER_SUPPORT = 'Customer Support';
export const DATA_ANALYTICS = 'Data Analytics';
export const DATA_SECURITY = 'Data security';
export const EAIE = 'EAIE';
export const EDIT_LISTING = 'Edit listing';
export const EDIT_PROFILE = 'Edit profile';
export const ENGINEERING = 'Engineering';
export const FAQ = 'FAQ';
export const FAVORITE_LISTINGS = 'Favorite listings';
export const FEATURE = 'Feature';
export const FINANCE = 'Finance';
export const FOR_UKRAINE_LANDING = 'For Ukraine landing';
export const FOR_UKRAINE_SEARCH = 'For Ukraine search';
export const HELP_CENTER = 'Help Center';
export const HOME = 'Home';
export const HOW_IT_WORKS = 'How it works';
export const HOW_IT_WORKS_NEXT = 'How it works next';
export const HOW_WE_HIRE = 'How we hire';
export const INBOX = 'Inbox';
export const INTERNSHIPS = 'Internships';
export const INVOICES = 'Invoices';
export const LEGAL = 'Legal';
export const LIST_YOUR_PLACE = 'List your place';
export const LISTING_CALENDAR = 'Listing calendar';
export const LISTING_CREATION_FLOW = 'LCF';
export const LISTING_DETAIL_PAGE = 'LDP';
export const LISTING_SUCCESS = 'Listing success';
export const LISTINGS = 'Listings';
export const LISTINGS_SETTINGS = 'Listings settings';
export const LOGIN = 'Login';
export const MARKETING = 'Marketing';
export const NOT_FOUND = 'Not found';
export const OTHER = 'Other';
export const PARTNER_REDIRECT = 'Partner redirect';
export const PAY_PAYMENT_REQUESTS = 'External Payment';
export const PAYMENT_METHODS = 'Payment methods';
export const PAYMENT_PLAN = 'Payment plan';
export const PAYMENT_REQUEST_CREATE_MODAL = 'Payment request create modal';
export const PAYMENT_REQUESTS = 'Payment requests';
export const PAYMENTS = 'Payments';
export const PAYMENTS_PAYMENT_REQUESTS = 'Payments Payment requests';
export const PAYOUT_METHODS = 'Payout methods';
export const PAYOUT_ROUTING = 'Payout routing';
export const PAYOUTS_PAYMENT_REQUESTS = 'Payouts payment requests';
export const PEOPLE_OPS = 'People Ops';
export const PILLAR = 'Pillar';
export const PRESS_RELEASES = 'Press releases';
export const PRICING = 'Pricing';
export const PRIVACY_POLICY = 'Privacy policy';
export const PRODUCT_DESIGN = 'Product Design';
export const QUICK_REPLIES_SETTINGS = 'Quick Replies Settings';
export const RECOVER_ACCOUNT = 'Recover account';
export const REGISTER = 'Register';
export const REGISTER_PARTNER = 'Register Partner';
export const RESERVATIONS = 'Reservations';
export const RESET_PASSWORD = 'Reset password';
export const SAFE_PAYMENT_SERVICE = 'Safe payment service';
export const SALES = 'Sales';
export const SEARCH = 'Search';
export const SEARCH_ALERT_LISTINGS = 'Search alert listings';
export const SEARCH_ALERTS_UNSUBSCRIBE = 'SearchAlertsUnsubscribe';
export const SHARE_ROOM = 'Share room';
export const SITEMAP = 'Sitemap';
export const SOMETHING_WENT_WRONG = 'Error';
export const SUBSCRIPTIONS = 'Subscriptions';
export const SURVEY_REVIEW = 'Survey';
export const TALK = 'TALK';
export const TENANT_REVIEW_DASHBOARD = 'Tenants review dashboard';
export const TENANT_REVIEW_OVERVIEW = 'Tenants review overview';
export const TENANT_REVIEW_POLICY = 'Review Policy';
export const TENANT_SUBSCRIPTION_CATEGORY = 'Tenant subscription';
export const TERMS = 'Terms';
export const TRANSACTION_HISTORY = 'Transaction history';
export const UNDER_REVIEW = 'Under review';
export const UNIVERSITIES = 'Universities';
export const UNSUPPORTED_COUNTRIES = 'Unsupported Countries';
export const USER = 'UserPage';
export const ADVERTISER = 'AdvertiserPage';
export const USER_DASHBOARD = 'User dashboard';
export const VERIFICATION = 'Verification';
export const VERIFY_IDENTITY = 'Verify Identity';
export const VERIFY_PHONE_NUMBER = 'Verify phone number';
